import { Controller } from "@hotwired/stimulus"

// Submits the avatar form as soon as a file is picked and guards against
// double submission while the upload is in flight.
//
//   <form data-controller="avatar-upload">
//     <input type="file" data-action="change->avatar-upload#submit">
//   </form>
export default class extends Controller {
  submit(event) {
    if (event.target.files.length === 0) return
    if (this.element.getAttribute("aria-busy") === "true") return

    this.element.setAttribute("aria-busy", "true")
    this.element.requestSubmit()
  }
}
